import { alpha, brand, cardBase, gradients, text } from '@/styles/shared';

export const rightPanelStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  card: {
    ...cardBase,
    padding: {
      xs: '20px',
      lg: '40px',
    },
    height: {
      xs: 'auto',
      sm: 'auto',
      lg: 'calc(var(--vh, 1vh) * 100 - 180px)',
    },
    minHeight: {
      xs: '400px',
      sm: '400px',
      lg: '699px',
    },
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: {
      xs: '20px',
      lg: '40px',
    },
    justifyContent: 'center',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerTitle: {
    ...text.title24,
    fontSize: {
      xs: '18px',
      lg: '24px',
    },
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    flex: 1,
    justifyContent: 'center',
    gap: '24px',
  },
  emptyStateTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: {
      xs: '15px',
      lg: '20px',
    },
    lineHeight: '1.22em',
    color: '#000000',
  },
  emptyStateSubtitle: {
    ...text.body14Muted,
  },
  largeIconContainer: {
    margin: {
      xs: '20px 0',
      lg: '60px 0',
    },
  },
  instructions: {
    ...text.body14Muted,
    fontSize: {
      xs: '12px',
      lg: '14px',
    },
    textAlign: 'center',
    maxWidth: '336px',
    fontWeight: 400,
    lineHeight: '1.4em',
  },
  gradientText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: {
      xs: '15px',
      lg: '20px',
    },
    lineHeight: '1.22em',
    background: gradients.brandLinear,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textAlign: 'center',
  },
  // Loading state styles
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    flex: 1,
    justifyContent: 'space-between',
  },
  loadingSubtitle: {
    ...text.body14Muted,
  },
  loadingAnimation: {
    position: 'relative',
    width: '142px',
    height: '142px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '30px',
  },
  outerCircle: {
    position: 'absolute',
    width: '142px',
    height: '142px',
    borderRadius: '50%',
    backgroundColor: alpha.green10,
    filter: 'blur(5px)',
  },
  innerCircle: {
    position: 'absolute',
    width: '126.79px',
    height: '126.79px',
    borderRadius: '50%',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 12.68px 1.27px rgba(0, 0, 0, 0.1)',
  },
  loadingIcon: {
    position: 'absolute',
    width: '50.71px',
    height: '50.71px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: 'spin 2s linear infinite',
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' },
    },
  },
  newAudioButton: {
    backgroundColor: brand.greenPrimary,
    borderRadius: '5px',
    padding: '8px 32.5px',
    marginTop: '15px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: brand.greenPrimaryDark,
    },
  },
  newAudioButtonText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '1.22em',
    color: '#FFFFFF',
  },
  warningText: {
    ...text.body14Muted,
    lineHeight: '1.4em',
    textAlign: 'center',
    maxWidth: '336px',
    marginTop: '27px',
  },
  taglineText: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: {
      xs: '15px',
      lg: '20px',
    },
    lineHeight: '1.22em',
    background: gradients.brandLinear,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textAlign: 'center',
    marginTop: '24px',
  },
  additionalInfo: {
    ...text.body14Muted,
    lineHeight: '1.4em',
    textAlign: 'center',
    maxWidth: '298px',
    marginTop: '24px',
  },
  scriberainHighlight: {
    color: brand.greenPrimary,
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};
